import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const HistoricNavChart = ({ data, classOpt, load }) => {
  // console.log("data returned:", data);

  // Helper function to format month and year as "month year"
  const formatMonthYear = (month, year) => {
    const monthMapping = {
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec",
    };
    return `${monthMapping[month]} ${year}`;
  };

  const formattedData = data
    ? Array.isArray(data["annual-nav"])
      ? data["annual-nav"].flatMap((yearData) => {
          const { year_no, ...monthReturns } = yearData;
          // Filter out non-monthly keys
          return Object.keys(monthReturns)
            .filter(
              (key) =>
                ![
                  "q1_nav_amount",
                  "q2_nav_amount",
                  "q3_nav_amount",
                  "q4_nav_amount",
                  "ytd_nav_amount",
                ].includes(key)
            )
            .map((key) => {
              const [month] = key.split("_"); // Extract the month from the key
              const value = parseFloat(monthReturns[key]); // Parse value as a number
              return {
                date: formatMonthYear(month, year_no), // Format date as "Month Year"
                value, // Numeric value for the chart
              };
            });
        })
      : Object.keys(data["annual-nav"]) // Handle the case where it's an object
          .filter(
            (key) =>
              ![
                "q1_nav_amount",
                "q2_nav_amount",
                "q3_nav_amount",
                "q4_nav_amount",
                "ytd_nav_amount",
                "year_no",
              ].includes(key)
          )
          .map((key) => {
            const [month] = key.split("_"); // Extract the month from the key
            const value = parseFloat(data["annual-nav"][key]); // Parse value as a number
            const year_no = data["annual-nav"].year_no; // Extract year number
            return {
              date: formatMonthYear(month, year_no), // Format date as "Month Year"
              value, // Numeric value for the chart
            };
          })
    : null;

  // Only include valid data points
  const validData = formattedData
    ? formattedData.filter((entry) => !isNaN(entry.value) && entry.value > 0)
    : [];

  return (
    <div className="main-padding">
      <div className="main-margin">
        <div className="monthly-total-return-img-wrapper">
          <h1 className="sub-header">
            Historical NAV Per Share<sup className="small-sup">1</sup>
          </h1>
        </div>
        <div className="chart-wrapper w-full h-full p-4 shadow-lg">
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              data={validData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid horizontal={true} vertical={false} />
              <XAxis dataKey="date" />
              <YAxis
                label={{
                  value: "NAV", // Text to display
                  angle: -90, // Rotate the label for vertical alignment
                  position: "insideLeft", // Position relative to the axis
                  offset: -12,
                  style: { textAnchor: "middle" }, // Optional: center the text
                }}
                tickFormatter={(value) => `$${value.toFixed(2)}`} // Format the tick values with a $ sign
                domain={[9.75, 10.75]} // Start at 9.75 and end at 10.75
                ticks={[9.75, 10, 10.25, 10.5, 10.75]} // Set custom ticks at $0.25 intervals
              />
              <Tooltip formatter={(value) => `$${value.toFixed(2)}`} />
              {/* <Legend /> */}
              <Line type="monotone" dataKey="value" stroke="#c39f5c" strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default HistoricNavChart;
